// eslint-disable-next-line angular/no-service-method
angular.
module("digiexam.node").
service("NodeRepository", function nodeRepositoryService($http, Node) {
	"use strict";

	this.load = function load(id) {
		return $http.get("/node/" + id).then(function success(response) {
			return new Node(response.data);
		});
	};

	this.save = function save(node) {
		return node.save();
	};

	this.list = function list() {
		return $http.get("/node/list/").then(function success(response) {
			return response.data;
		});
	};
});
